import { Link } from "react-router-dom";
import { Lightbulb, Rocket, ArrowRight, ShieldCheck, LibraryBig, FolderOpen } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function BizLanding() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-brand-bg text-brand-text">
      <header className="mx-auto flex max-w-content items-center justify-between px-4 py-5 md:px-8">
        <Link to="/" className="font-display text-lg font-bold tracking-tight">PROMPTIVO<span className="text-brand-accent">.</span></Link>
        {user ? (
          <div className="flex items-center gap-4">
            <Link to="/biznes/analizy" className="inline-flex items-center gap-1.5 text-sm text-brand-sec hover:text-brand-text" data-testid="biz-my-analyses-link"><FolderOpen size={15} /> Moje analizy</Link>
            <Link to="/biblioteka" className="inline-flex items-center gap-1.5 text-sm text-brand-sec hover:text-brand-text" data-testid="biz-library-link"><LibraryBig size={15} /> Moja biblioteka</Link>
          </div>
        ) : user === false ? (
          <Link to="/logowanie" className="text-sm text-brand-sec hover:text-brand-text" data-testid="biz-login-link">Zaloguj się</Link>
        ) : null}
      </header>

      <main className="mx-auto max-w-content px-4 pb-24 pt-6 md:px-8">
        <p className="font-display text-[12px] font-bold uppercase tracking-[0.12em] text-brand-accent">Biznes i pomysły</p>
        <h1 className="mt-3 max-w-3xl font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-5xl [text-wrap:balance]">
          Nie wiesz, w co wejść? Zbudujemy pomysł na biznes na podstawie Twoich odpowiedzi.
        </h1>
        <p className="mt-4 max-w-2xl text-brand-sec">
          Bez zgadywania i obietnic. Odpowiadasz na kilka pytań, a my proponujemy realne kierunki, oceniamy je i pokazujemy plan pierwszego testu. Dane bez potwierdzenia oznaczamy jako „hipoteza do sprawdzenia".
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <Link to="/biznes/generator" data-testid="biz-entry-generator" className="group rounded-panel border border-brand-line bg-brand-surface p-6 transition-colors hover:border-brand-accent/60">
            <div className="flex h-11 w-11 items-center justify-center rounded-field bg-brand-accent/12 text-brand-accent"><Lightbulb size={22} /></div>
            <h2 className="mt-4 font-display text-xl font-semibold">Nie mam pomysłu</h2>
            <p className="mt-2 text-[14px] text-brand-sec">Przejdziesz krótki wywiad, a Generator zaproponuje 3 dopasowane pomysły z oceną i planem walidacji.</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-accent">Otwórz Generator <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" /></span>
          </Link>

          <div data-testid="biz-entry-analysis" className="grid gap-3 sm:grid-cols-2 md:col-span-1 md:grid-cols-1">
            <Link to="/biznes/analiza/idea" data-testid="biz-entry-analysis-idea" className="group rounded-panel border border-brand-line bg-brand-surface p-6 transition-colors hover:border-brand-accent/60">
              <div className="flex h-11 w-11 items-center justify-center rounded-field bg-brand-accent/12 text-brand-accent"><Rocket size={22} /></div>
              <h2 className="mt-4 font-display text-xl font-semibold">Mam pomysł lub prowadzę firmę</h2>
              <p className="mt-2 text-[14px] text-brand-sec">Pełna Analiza Twojego biznesu: klient, problem, rynek, ryzyka, rekomendacja i plan 30/90 dni.</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-accent">Analizuj pomysł <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" /></span>
            </Link>
            <Link to="/biznes/analiza/firma" data-testid="biz-entry-analysis-firma" className="inline-flex items-center gap-1.5 rounded-field border border-brand-line px-4 py-2 text-[13px] font-medium text-brand-sec transition-colors hover:border-brand-accent/60 hover:text-brand-text">
              Prowadzę już firmę → analizuj istniejący biznes
            </Link>
          </div>
        </div>

        <p className="mt-8 flex items-start gap-2 text-[13px] text-brand-muted">
          <ShieldCheck size={16} className="mt-0.5 shrink-0 text-brand-accent" />
          Wypełnienie wywiadu i krótki podgląd są bezpłatne. Konto zakładasz, gdy chcesz zapisać projekt i zobaczyć pełne wyniki.
        </p>
      </main>
    </div>
  );
}
